import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProgramUserListApiModel } from '@app/api/api-models/users/program-users-list/ProgramUserListApiModel';
import {
  FormInstanceCollectionDeleteResultApiModel,
  HighFiveApiModel,
  HighFivesFiltersApi,
  HighFivesListModel,
  HighFivesRequestParams
} from '@app/api/api-models';
import { SummaryPeFormInstanceApiModel } from '@app/api/api-models/pe-features/SummaryPeFormInstanceApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { HttpParams } from '@angular/common/http';
import { PeFormInstanceDependenciesApiModel } from '@app/api/api-models/pe-features/PeFormInstanceDependenciesApiModel';

@Injectable()
export class HighFivesService {
  public apiUrl = 'high-fives';

  constructor(private readonly http: HttpClientService) {}

  public getAvailableSubjects(): Observable<ProgramUserListApiModel[]> {
    return this.http
      .get<ProgramUserListApiModel[]>(`${this.apiUrl}/available-subjects`)
      .pipe(map((array) => array.map((x) => new ProgramUserListApiModel().deserialize(x))));
  }

  public get(id: number): Observable<HighFiveApiModel> {
    return this.http.get<HighFiveApiModel>(`${this.apiUrl}/${id}`);
  }

  public add(model: HighFiveApiModel): Observable<HighFiveApiModel> {
    return this.http.post<HighFiveApiModel>(`${this.apiUrl}`, model);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  public deleteMultiple(ids: Array<number>): Observable<FormInstanceCollectionDeleteResultApiModel> {
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({ ids: ids });

    return this.http.delete(`${this.apiUrl}/delete-multiple`, { params: queryParams });
  }

  public getSummaries(id: number): Observable<SummaryPeFormInstanceApiModel[]> {
    return this.http.get<SummaryPeFormInstanceApiModel[]>(`${this.apiUrl}/${id}/summaries`);
  }

  public getSummariesMultipleByIds(ids: Array<number>): Observable<Array<PeFormInstanceDependenciesApiModel>> {
    let queryParams = new HttpParams();
    queryParams = queryParams.appendAll({ ids: ids });

    return this.http.get<Array<PeFormInstanceDependenciesApiModel>>(`${this.apiUrl}/summaries-multiple`, {
      params: queryParams
    });
  }

  public getSummariesByDate(date: Date, subjectProgramRoleIds: string[]): Observable<SummaryPeFormInstanceApiModel[]> {
    return this.http.post<SummaryPeFormInstanceApiModel[]>(`${this.apiUrl}/summaries`, {
      date: date.toISOString(),
      subjectProgramRoleIds
    });
  }

  public getPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/pdf`, { responseType: 'blob' });
  }

  public getHighFives(searchQuery: HighFivesRequestParams): Observable<HighFivesListModel> {
    return this.http.get<HighFivesListModel>(`${this.apiUrl}`, { params: searchQuery });
  }

  public getFilters(id: string): Observable<HighFivesFiltersApi> {
    return this.http.get<HighFivesFiltersApi>(`${this.apiUrl}/filters`, { params: { UserId: id } });
  }
}
